<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Create a new integration pipeline</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="custom-control custom-radio custom-control-inline">
                <input v-model="direction" value="1" type="radio" id="dirImport" name="dir" class="custom-control-input">
                <label class="custom-control-label" for="dirImport">Read data from connector</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input v-model="direction" value="2" type="radio" id="dirExport" name="dir" class="custom-control-input">
                <label class="custom-control-label" for="dirExport">Write data to connector</label>
            </div>
            <br /><br />

            <div class="form-group">
                <label for="Name">Name:</label>
                <input v-model="name" type="text" class="form-control" placeholder="Name of a pipeline">
                <ValidationError context="Name" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="Description">Description:</label>
                <textarea v-model="description" class="form-control" placeholder="Description of a pipeline"></textarea>
                <ValidationError context="Description" :errors="validationErrors"></ValidationError>
            </div>

            <button @click="invoke" class="btn btn-primary btn-lg">Create</button>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from "@common/Guid"
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminCreatePipelinePage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from "@common/Components/ValidationError.vue";

    document.title = "Create a pipeline"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useCreatePipelineCommand, useConnectorProvidersQuery } = useAdminCreatePipelinePage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const connectorProvidersQuery = reactive(useConnectorProvidersQuery(true, false))
    const providers = computed(() => connectorProvidersQuery.model?.Providers || [])

    const { invoke, id, name, description, direction, timeTriggerRecurrency, validationErrors, succeed } = useCreatePipelineCommand(guid(), tid, userId)
    direction.value = 1
    timeTriggerRecurrency.value = null

    watch(succeed, () => {
        if (succeed.value) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id.value}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        connectorProvidersQuery.run()
    })
</script>
